'use client'; // @COFIXME: this is required because this file is imported by the page.tsx

import AccordionTastic from '@srcDS/tastic/content/accordion/tastic';
import dynamic from 'next/dynamic'
import AccountNavigationTastic from '@srcDS/js/tastic/pages/account/accountNavigation/tastic';
import WishlistPageTastic from '@srcDS/js/tastic/pages/account/wishlist/tastic';
import StoreDetailsTastic from '@srcDS/js/tastic/storeLocator/storeDetails/tastic';
import AccountProfileTastic from '@srcDS/tastic/account/profile/tastic';
import CartTastic from '@srcDS/tastic/cart/tastic';
import CheckoutTastic from '@srcDS/tastic/checkout/tastic';
import CheckoutSuccessTastic from '@srcDS/tastic/checkoutSuccess/tastic';
import AccentBoxTastic from '@srcDS/tastic/content/accentBox/tastic';
// import BalanceTastic from '@srcDS/tastic/pages/balance/tastic';
import BookAStylistTastic from '@srcDS/tastic/content/bookAStylist/tastic';
import BreadcrumbsTastic from '@srcDS/tastic/content/breadcrumbs/tastic';
import CategoryBannerTastic from '@srcDS/tastic/content/categoryBanner/tastic';
import CmsNavigationTastic from '@srcDS/tastic/content/cmsNavigation/tastic';
import ComplexHeroTastic from '@srcDS/tastic/content/complexHero/tastic';
import ComplexHeroV2Tastic from '@srcDS/tastic/content/complexHeroV2/tastic';
import ContentTitleTastic from '@srcDS/tastic/content/contentTitle/tastic';
import CountdownTastic from '@srcDS/tastic/content/countdown/tastic';
import CtaTastic from '@srcDS/tastic/content/cta/tastic';
import DescriptionSectionTastic from '@srcDS/tastic/content/descriptionSection/tastic';
import FaqPopupTastic from '@srcDS/tastic/content/faqPopup/tastic';
// import ForgotPasswordTastic from '@srcDS/tastic/pages/forgotPassword/tastic';
// import ResetPasswordTastic from '@srcDS/tastic/pages/resetPassword/tastic';
import GlobalPromoTilesTastic from '@srcDS/tastic/content/globalPromoTiles/tastic';
import ImageGridTastic from '@srcDS/tastic/content/imageGrid/tastic';
import InstaSectionTastic from '@srcDS/tastic/content/instaSection/tastic';
import JournalBlockTastic from '@srcDS/tastic/content/journalBlock/tastic';
import MediaSectionTastic from '@srcDS/tastic/content/mediaSection/tastic';
// import CartTastic from '@srcDS/tastic/cart/tastic';
// import CheckoutTastic from '@srcDS/tastic/checkout/tastic';
// import CheckoutSuccessTastic from '@srcDS/tastic/checkoutSuccess/tastic';
// import AccountProfileTastic from '@srcDS/tastic/account/profile/tastic';
import NewSizeGuideTastic from '@srcDS/tastic/content/newSizeGuide/tastic';
import NewsLetterPopupTastic from '@srcDS/tastic/content/newsletterPopup/tastic';
import PageTitleTastic from '@srcDS/tastic/content/pageTitle/tastic';
import PayLaterTastic from '@srcDS/tastic/content/payLaterDialog/tastic';
import PopularCategoriesTastic from '@srcDS/tastic/content/popularCategories/tastic';
import PopularCategoriesV2Tastic from '@srcDS/tastic/content/popularCategoriesV2/tastic';
import ProductRecommendationsTasticV2 from '@srcDS/tastic/content/productRecommendationsV2/tastic';
// import PayLaterTastic from '@srcDS/tastic/content/payLaterDialog/tastic';
// import PopularCategoriesTastic from '@srcDS/tastic/content/popularCategories/tastic';
// import PopularCategoriesV2Tastic from '@srcDS/tastic/content/popularCategoriesV2/tastic';
// import ProductRecommendationsTasticV2 from '@srcDS/tastic/content/productRecommendationsV2/tastic';
import PromoCollectionsTastic from '@srcDS/tastic/content/promoCollectionsSection/tastic';
import SearchDropdownTastic from '@srcDS/tastic/content/searchDropdown/tastic';
// import RegistrationTastic from '@srcDS/tastic/pages/registration/tastic';
// import SearchDropdownTastic from '@srcDS/tastic/content/searchDropdown/tastic';
import SeoSectionTastic from '@srcDS/tastic/content/seoSection/tastic';
import { default as SizeGuideBaseTastic, default as SizeGuideTastic } from '@srcDS/tastic/content/sizeGuide/tastic';
import SplitMediaSectionTastic from '@srcDS/tastic/content/splitMediaSection/tastic';
import VideoBlockTastic from '@srcDS/tastic/content/videoBlock/tastic';
import FooterTastic from '@srcDS/tastic/footer/tastic';
import GlobalSettingsTastic from '@srcDS/tastic/globalSettings/tastic';
import HeaderTastic from '@srcDS/tastic/header/tastic';
import HorizontalSpacerTastic from '@srcDS/tastic/helpers/horizontal-spacer/tastic';
import MinimalFooterTastic from '@srcDS/tastic/minimalFooter/tastic';
// import AddressBookTastic from '@srcDS/tastic/pages/account/addressBook/tastic';
// import OrdersTastic from '@srcDS/tastic/pages/account/orders/tastic';
// import PersonalInfoTastic from '@srcDS/tastic/pages/account/personalInfo/tastic';
import BalanceTastic from '@srcDS/tastic/pages/balance/tastic';
import CategoryContentTastic from '@srcDS/tastic/pages/category/tastic';
import ForgotPasswordTastic from '@srcDS/tastic/pages/forgotPassword/tastic';
import JournalArticleTastic from '@srcDS/tastic/pages/journal/journalArticle/tastic';
import JournalHomeTastic from '@srcDS/tastic/pages/journal/journalHome/tastic';
import JournalSectionTastic from '@srcDS/tastic/pages/journal/journalSection/tastic';
import JournalTagTastic from '@srcDS/tastic/pages/journal/journalTag/tastic';
import LoginPageTastic from '@srcDS/tastic/pages/login/tastic';
import ProductPageTastic from '@srcDS/tastic/pages/product/tastic';
import RegistrationTastic from '@srcDS/tastic/pages/registration/tastic';
// import ResetPasswordTastic from '@srcDS/tastic/pages/resetPassword/tastic';
import StoreLocatorTastic from '@srcDS/tastic/pages/storeLocator/tastic';
import { TasticRegistry } from './types';

// unused right now, but were in old tastics as asyncComponent:
// CheckoutHeaderTastic
// CheckoutFooterTastic
// AccountAccessTastic
// AccountConfirmTastic
// AccountOrdersTastic
// AccountAddressesTastic
// AccountWishlistsTastic
// ConfirmRegister
// AccountNavigationTastic
// LowImpactTastic
// ContactUsForm
// BlogListTastic
// ProductRecommendationsTastic

export const tastics: TasticRegistry = {
  // 'frontastic/boost/content/markdown': MarkdownTastic,
  // 'frontastic/boost/content/showcase-text': ShowcaseTextTastic,
  'frontastic/boost/content/sizeguidebase': SizeGuideBaseTastic,
  'frontastic/content/cta': CtaTastic,
  // 'frontastic/boost/forms/newsletter-block': NewsletterBlockTastic,
  // 'frontastic/boost/header/main-menu': MainMenuTastic,
  'frontastic/pages/product': ProductPageTastic,
  'frontastic/pages/balance': dynamic(() => import('@srcDS/tastic/pages/balance/tastic'), { ssr: false }),
  'frontastic/boost/helpers/horizontal-spacer': HorizontalSpacerTastic,
  // 'frontastic/boost/content/feature-service': FeatureServiceTastic,
  'frontastic/boost/footer': FooterTastic,
  'frontastic/boost/minimal-footer': MinimalFooterTastic,
  'frontastic/boost/cart': dynamic(() => import('@srcDS/tastic/cart/tastic'), { ssr: false }),
  'frontastic/boost/checkout': dynamic(() => import('@srcDS/tastic/checkout/tastic'), { ssr: false }),
  'frontastic/boost/checkout-success': dynamic(() => import('@srcDS/tastic/checkoutSuccess/tastic'), { ssr: false }),
  // 'frontastic/boost/checkout-header': CheckoutHeaderTastic,
  // 'frontastic/boost/checkout-footer': CheckoutFooterTastic,
  // 'frontastic/boost/account/access': AccountAccessTastic,
  // 'frontastic/boost/account/confirm': AccountConfirmTastic,
  // 'frontastic/boost/account/profile': dynamic(() => import('@srcDS/tastic/account/profile/tastic'), { ssr: false }),
  // // 'frontastic/boost/account/resetPassword': ResetPasswordTastic,
  // 'frontastic/boost/account/orders': AccountOrdersTastic,
  // 'frontastic/boost/account/addresses': AccountAddressesTastic,
  // 'frontastic/boost/account/wishlists': AccountWishlistsTastic,
  'frontastic/pages/sizeguide': SizeGuideTastic,
  'frontastic/content/header': HeaderTastic,
  'frontastic/boost/global-settings': GlobalSettingsTastic,
  'frontastic/content/complexhero': ComplexHeroTastic,
  'frontastic/content/complexheroV2': ComplexHeroV2Tastic,
  'frontastic/content/countdown': CountdownTastic,
  'frontastic/content/promocollections': PromoCollectionsTastic,
  'frontastic/content/popularCategories': dynamic(() => import('@srcDS/tastic/content/popularCategories/tastic'), { ssr: false }),
  'frontastic/content/popularCategoriesV2': dynamic(() => import('@srcDS/tastic/content/popularCategoriesV2/tastic'), { ssr: false }),
  'frontastic/content/mediasection': MediaSectionTastic,
  'frontastic/pages/newsizeguide': NewSizeGuideTastic,
  'frontastic/content/instasection': InstaSectionTastic,
  'frontastic/content/paylater': dynamic(() => import('@srcDS/tastic/content/payLaterDialog/tastic'), { ssr: false }),
  'frontastic/pages/storeLocator': dynamic(() => import('@srcDS/tastic/pages/storeLocator/tastic'), { ssr: false }),
  'frontastic/content/seosection': SeoSectionTastic,
  // 'frontastic/content/seo': SeoTastic,
  'frontastic/pages/account/profile': dynamic(() => import('@srcDS/tastic/pages/account/personalInfo/tastic'), { ssr: false }),
  'frontastic/pages/account/addresses': dynamic(() => import('@srcDS/tastic/pages/account/addressBook/tastic'), { ssr: false }),
  'frontastic/pages/account/orders': dynamic(() => import('@srcDS/tastic/pages/account/orders/tastic'), { ssr: false }) as any, // wrong type due to compose order?
  'frontastic/pages/account/wishlist': dynamic(() => import('@srcDS/tastic/pages/account/wishlist/tastic'), { ssr: false }),
  // 'frontastic/pages/account/confirm': ConfirmRegister,
  'frontastic/pages/category': CategoryContentTastic,
  'frontastic/pages/forgotpassword': dynamic(() => import('@srcDS/tastic/pages/forgotPassword/tastic'), { ssr: false }),
  'frontastic/pages/resetpassword': dynamic(() => import('@srcDS/tastic/pages/resetPassword/tastic'), { ssr: false }),
  'frontastic/pages/login': LoginPageTastic,
  'frontastic/pages/registration': dynamic(() => import('@srcDS/tastic/pages/registration/tastic'), { ssr: false }),
  // 'frontastic/content/productrecommendations': ProductRecommendationsTastic,
  'frontastic/content/productrecommendationsV2': dynamic(() => import('@srcDS/tastic/content/productRecommendationsV2/tastic'), { ssr: false }),
  'frontastic/content/pagetitle': PageTitleTastic,
  // 'frontastic/content/quote': Quote,
  // 'frontastic/content/spacing': Spacing,
  'frontastic/content/accentbox': AccentBoxTastic,
  'frontastic/content/descriptionsection': DescriptionSectionTastic,
  'frontastic/content/cmsnavigation': CmsNavigationTastic,
  // 'frontastic/content/contactusform': ContactUsForm,
  'frontastic/content/accordion': AccordionTastic,
  'frontastic/content/breadcrumbs': BreadcrumbsTastic,
  'frontastic/content/newsletterpopup': NewsLetterPopupTastic,
  'frontastic/content/splitmediasection': SplitMediaSectionTastic,
  'frontastic/content/faqpopup': dynamic(() => import('@srcDS/tastic/content/faqPopup/tastic'), { ssr: false }) as any, // wrong type due to compose order?
  'frontastic/pages/account/navigation': AccountNavigationTastic,
  'frontastic/content/book-stylist': dynamic(() => import('@srcDS/tastic/content/bookAStylist/tastic'), { ssr: false }),
  'frontastic/content/videoBlock': VideoBlockTastic,
  'apg/store-details': StoreDetailsTastic,
  'frontastic/blog/imagegrid': ImageGridTastic,
  // 'frontastic/blog/contentgrid': ContentGridTastic,
  'frontastic/blog/contenttitle': ContentTitleTastic,
  // 'frontastic/blog/bloglist': BlogListTastic,
  'frontastic/boost/content/search-dropdown': dynamic(() => import('@srcDS/tastic/content/searchDropdown/tastic'), { ssr: false }),
  // 'frontastic/boost/content/lowimpact': LowImpactTastic,
  'frontastic/journal/journal-home': JournalHomeTastic,
  'frontastic/journal/journal-article': JournalArticleTastic,
  'frontastic/journal/journal-section': JournalSectionTastic,
  'frontastic/journal/journal-tag': JournalTagTastic,
  'frontastic/content/journalblock': JournalBlockTastic,
  'frontastic/content/categorybanner': CategoryBannerTastic,
  'frontastic/boost/global-promo-tiles': GlobalPromoTilesTastic,
};
